// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelCarePlans extends React.Component<Props> {
  get categoriesData() {
    return [
      {
        id: "rest",
        label: this.props.t("REST"),
        details: this.props.t("REST_DESCRIPTION"),
      },
      {
        id: "hydration",
        label: this.props.t("HYDRATION"),
        details: this.props.t("HYDRATION_DESCRIPTION"),
      },
      {
        id: "food",
        label: this.props.t("FOOD"),
        details: this.props.t("FOOD_DESCRIPTION"),
      },
      {
        id: "exercise",
        label: this.props.t("EXERCISE"),
        details: this.props.t("EXCERCISE_DESCRIPTION"),
      },
      {
        id: "mind",
        label: this.props.t("MIND"),
        details: this.props.t("MIND_DESCRIPTION"),
      },
      {
        id: "self-care",
        label: this.props.t("SELF_CARE"),
        details: this.props.t("SELF_CARE_PLANS_DESCRIPTION"),
      },
    ];
  }

  get recommendationsData() {
    return [
      {
        id: "engagement",
        label: this.props.t("ENCOURAGE_ENGAGEMENT"),
        details: this.props.t("ENCOURAGE_ENGAGEMENT_DESCRIPTION"),
      },
      {
        id: "communication",
        label: this.props.t("COMMUNICATION_INPUTS"),
        details: this.props.t("COMMUNICATION_INPUTS_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  get recommendationsColumns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
        columnClassName: "bg-mint",
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("CARE_PLANS_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.CARE_PLANS_INSTRUCTIONS}
            title={this.props.t("CARE_PLANS_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("CATEGORIES")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.categoriesData} />
        <h6 className="font-weight-bold">{this.props.t("RECOMMENDATIONS")}</h6>
        <SimpleGrid
          className="theme-help"
          columns={this.recommendationsColumns}
          rows={this.recommendationsData}
        />
      </div>
    );
  }
}

export default localize()(HelpPanelCarePlans);
